import { Route, Navigate } from 'react-router-dom'
import Protected from '@/routes/Protected'
import RequireWorkspace from '@/routes/RequireWorkspace'
import AppShell from '@/components/AppShell/AppShell'
import PATHS, { HOME_THREAD_ROUTE_PATTERN } from '@/routes/paths'
import {
  AppShellRouteFallback,
  DocumentsMainLayoutRoute,
  ConnectionsMainLayoutRoute,
  HomeMainLayoutRoute,
  SettingsDeepLinkRoute,
} from '@/routes/appShellRouteElements'

/** @returns {import('react').ReactElement[]} */
export default function appShellRoutes() {
  return [
    <Route
      key="app-shell"
      element={
        <Protected>
          <RequireWorkspace>
            <AppShell />
          </RequireWorkspace>
        </Protected>
      }
    >
      <Route index element={<Navigate to={PATHS.HOME} replace />} />
      <Route path={HOME_THREAD_ROUTE_PATTERN} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.DOCUMENTS} element={<DocumentsMainLayoutRoute />} />
      <Route path={PATHS.CONNECTIONS} element={<ConnectionsMainLayoutRoute />} />
      <Route path={PATHS.DO_VOICE} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.PULSE} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.SCHEDULES} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.TRIGGERS} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.SKILLS} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.BUILD} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.HOME} element={<HomeMainLayoutRoute />} />
      <Route path={PATHS.SETTINGS} element={<SettingsDeepLinkRoute />} />
      <Route path={`${PATHS.SETTINGS}/:sectionId`} element={<SettingsDeepLinkRoute />} />
      <Route path="*" element={<Navigate to={PATHS.HOME} replace />} />
    </Route>,
  ]
}

export { AppShellRouteFallback }
